module.exports = __webpack_public_path__ + "img/member_icon_bottom.0c5b7bcc.png";